<template>
    <LayoutAuth>
        <FormLogin />
    </LayoutAuth>
</template>

<script>
import LayoutAuth from '@/components/layouts/LayoutAuth.vue';
import FormLogin from '@/components/forms/FormLogin.vue';

export default {
    name: 'Login',
    components: {
        LayoutAuth,
        FormLogin,
    },
    mounted() {
        // Cierra la pestaña cuando MercadoPago redirige a /login con external_reference y type
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('external_reference') && urlParams.get('type')) {
            window.close();
        }
    },
};
</script>

<style>
.full-screen-card {
    height: 100vh;
    max-height: none;
}

.card-display {
    width: 550px;
}

.logo-image {
    max-width: 100%;
    height: auto;
    object-fit: cover;
}

.v-btn--redessociales {
    bottom: 0;
    position: absolute;
    margin: 0 0 80px 10px;
}

.url-web {
    position: absolute;
    left: 46px;
    top: 223px;
}

.custom-card {
    position: relative;
    height: 100%;
    cursor: default;
    padding-bottom: 80px;
}

.custom-card-actions {
    position: fixed;
    bottom: 0;
    left: 50%;
    right: 0;
    height: 65px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
}

.custom-card-actions-middle {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 65px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
}

.background-fixed {
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
